import React from 'react'
import PropTypes from 'prop-types'

function PendingVerificationModal(props) {
  const { storageProfile, handleDismiss } = props

  return (
    <>
      {/* TODO: Refactor modal backdrop and shell interactions to semantic, keyboard-accessible controls in one pass. CTINEXT-4685 */}
      {/* eslint-disable-next-line */}
      <div className="Modal" onClick={handleDismiss}>
        {/* eslint-disable-next-line */}
        <section className="Modal-window" onClick={(e) => e.stopPropagation()}>
          <div className="Modal-content">
            <div className="u-flex u-marginBottom2gu">
              <h2 className="u-flexGrow1 u-textSizeMsrp4 u-marginTop4gu u-marginBottom3gu">
                Pending Verification
              </h2>
              <button
                onClick={handleDismiss}
                className="Button Link u-textColorBrand u-textSizeMsrp5 u-flexJustifyEnd u-padding0 u-textPrimary"
              >
                ×
              </button>
            </div>
            <p className="u-marginBottom4gu">
              Thank you for registering, {storageProfile.firstName}! You can now
              set up your email subscription preferences.
            </p>
            <h4>
              You will not begin to receive your subscriptions until your
              account has been verified.
            </h4>
            <hr
              className="Rule Rule--thin u-marginVert4gu Module-divider"
              role="presentation"
            ></hr>
            <button
              onClick={handleDismiss}
              className="Button Button--secondary u-textNoTransform"
              data-tracking="primary"
            >
              Continue
            </button>
          </div>
        </section>
      </div>
    </>
  )
}

PendingVerificationModal.propTypes = {
  storageProfile: PropTypes.object.isRequired,
  handleDismiss: PropTypes.func.isRequired,
}

export default PendingVerificationModal
